/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_PrivateInputs */

const en_dialog_premium_private = /** @type {(inputs: Dialog_Premium_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make your documents private with Listening Premium`)
};

const es_dialog_premium_private = /** @type {(inputs: Dialog_Premium_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz tus documentos privados con Listening Premium`)
};

/**
* | output |
* | --- |
* | "Make your documents private with Listening Premium" |
*
* @param {Dialog_Premium_PrivateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_private = /** @type {((inputs?: Dialog_Premium_PrivateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_PrivateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_private(inputs)
	return en_dialog_premium_private(inputs)
});